import { useMutation } from "@tanstack/react-query";

import { apiGqlClient } from "~/libs/gql";
import { graphql } from "~/types/__generated/gql";
import {
	GetFileDownloadUrlMutation,
	GetFileDownloadUrlMutationVariables,
} from "~/types/__generated/gql/graphql";

const query = /* GraphQL */ `
	mutation GetFileDownloadUrl($key: String!) {
		getFileDownloadUrl(key: $key)
	}
`;

export type GetFileDownloadUrlVariables = GetFileDownloadUrlMutationVariables;
export type GetFileDownloadUrlResults =
	GetFileDownloadUrlMutation["getFileDownloadUrl"];

export const useGetFileDownloadUrl = () => {
	return useMutation({
		mutationFn: (variables: GetFileDownloadUrlVariables) =>
			apiGqlClient
				.request(graphql(query), variables)
				.then((res) => res.getFileDownloadUrl),
	});
};
